import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import style from './GridContainer.module.scss.js';

var _excluded = ["fluid", "className"];
var GridContainer = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var fluid = _ref.fluid,
    className = _ref.className,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  var suffix = typeof fluid === 'string' ? "-" + fluid : '-fluid';
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cx(fluid ? style["container" + suffix] : style['container'], className),
    ref: ref
  }, props));
});
var GridContainerPropTypes = {
  fluid: PropTypes.oneOf([true, false, 'sm', 'md', 'lg', 'xl', 'xxl']),
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
};
GridContainer.propTypes = GridContainerPropTypes;
GridContainer.defaultProps = {
  fluid: false
};
GridContainer.displayName = 'GridContainer';

export { GridContainerPropTypes, GridContainer as default };
//# sourceMappingURL=GridContainer.js.map
